import './HeaderModuleWrapper.css';
import React from 'react';
var wrapperCss = "w1sephyu";
var HeaderModuleWrapper = function HeaderModuleWrapper(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(wrapperCss, " ").concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, children))));
};
export default HeaderModuleWrapper;